import React, { useState } from 'react';
import ReactDOM from 'react-dom';

// Styles & Assets
import styles from './PatientChartPage.module.css';

// Services
import { getSheetParametersPoll } from '../../services/Patient';

// Components
import CVCharts from '../../components/PatientChart/CVCharts/CVCharts';
import PollScoreChart from '../../components/PatientChart/PollScoreChart/PollScoreChart';

// Interfaces
import { PatientOutletContext } from '../../interfaces/Patient';

// Other
import { useOutletContext } from 'react-router-dom';
import ChartSlider from '../../components/Patient/ChartSlider/ChartSlider';
import useInquiriesCharts from '../../hooks/useInquiriesCharts';

// PatientChartPage: renders the patient's charts given the patient and currentGraph.
const PatientChartPage: React.FC = () => {
    const { caso, elements, sheetParameters }: PatientOutletContext = useOutletContext();

    const inquiriesShow = useInquiriesCharts(caso.id);

    const [currentTab, setCurrentTab] = useState(0);

    const handleClickBack = () => {
        setCurrentTab(oldCurrentTab =>
            oldCurrentTab === 0 ? inquiriesShow.length : oldCurrentTab - 1
        );
    };

    const handleClickFordward = () => {
        setCurrentTab(oldCurrentTab =>
            oldCurrentTab === inquiriesShow.length ? 0 : oldCurrentTab + 1
        );
    };

    const getCurrentChart = () => {
        if (currentTab === 0) return null;
        return inquiriesShow[currentTab - 1];
    };

    const currentChart = getCurrentChart();

    const getElements = (inquiryID: number | undefined) => {
        if (inquiryID !== undefined) {
            const sheetParameterIDs = getSheetParametersPoll(elements, inquiryID);
            const elementsScores = [];

            for (let i = elements.length - 1; i >= 0; i--) {
                let score: number | null = null;

                Object.keys(elements[i].values).forEach(key => {
                    if (sheetParameterIDs.includes(key)) {
                        if (score === null) score = 0;
                        score += elements[i].values[key] || 0;
                    }
                });

                if (score !== null) {
                    const value = { value: score, date: elements[i].date };
                    elementsScores.push(value);
                }
            }

            return elementsScores;
        }

        return [];
    };

    const searchbarElement = document.getElementById('patient-buttons-right') as HTMLElement;

    return (
        <>
            {searchbarElement && ReactDOM.createPortal(
                <ChartSlider
                    currentLabel={currentChart === null ? 'CV' : currentChart.name ?? ''}
                    disabled={inquiriesShow.length === 0}
                    handleClickBack={handleClickBack}
                    handleClickFordward={handleClickFordward}
                />,
                searchbarElement
            )}

            <div className={styles.patientChartContainer}>
                {currentChart === null ? (
                    <CVCharts
                        caso={caso}
                        elements={elements}
                        sheetParameters={sheetParameters ?? []}
                    />
                ) : (
                    <PollScoreChart
                        caso={caso}
                        elements={getElements(currentChart.id)}
                    />
                )}
            </div>
        </>
    );
};

export default PatientChartPage;